import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function AgentConnectPage() {
  const { t } = useTranslation();
  const [connectionId] = useState(() => {
    const value = new URLSearchParams(window.location.search).get("connection") || "";
    return /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(value) ? value : undefined;
  });
  const [status] = useState<"connecting" | "failed">(() => {
    if (!connectionId) return "failed";
    try {
      const receipt = sessionStorage.getItem(`agent-connect:${connectionId}`);
      return receipt === "failed" ? receipt : "connecting";
    } catch {
      return "failed";
    }
  });

  useEffect(() => {
    if (status !== "connecting" || !connectionId) return;
    const returnTo = `${window.location.pathname}${window.location.search}`;
    window.location.replace(`/auth?source=agent-connect&redirectUrl=${encodeURIComponent(returnTo)}`);
  }, [status, connectionId]);

  return (
    <main className="app-page-background min-h-screen bg-[var(--bg-primary)] text-[var(--text-primary)] flex items-center justify-center px-6">
      <section className="glass w-full max-w-md rounded-3xl p-8 text-center">
        <img src="/logo.png" alt="1Transcribe" className="mx-auto mb-6 h-16 w-16 rounded-2xl" />
        <h1 className="text-3xl font-bold tracking-tight">
          {status === "failed"
              ? t("agentConnect.failedTitle", { defaultValue: "Connection failed" })
              : t("agentConnect.connectingTitle", { defaultValue: "Connecting your assistant…" })}
        </h1>
        <p className="mt-3 text-[var(--text-secondary)]">
          {status === "failed"
              ? t("agentConnect.failedBody", { defaultValue: "This connection link is invalid or expired. Return to your assistant and try again." })
              : t("agentConnect.connectingBody", { defaultValue: "Keep this page open while we finish the connection." })}
        </p>
      </section>
    </main>
  );
}
